export default "__VITE_ASSET__B1XtRi0i__"